import api from "../../infra/api";

class ServTermoConsentimento {
  async cadastrarTermoConsentimento(dto) {
    const response = await api({
      method: "POST",
      url: "api/v1/TermoConsentimento/SalvarTermo",
      data: JSON.stringify(dto)
    });

    return response.data;
  }

  async alterarTermoConsentimento(codigoResponsavel, dto) {
    const response = await api({
      method: "PUT",
      url: `api/v1/TermoConsentimento/${codigoResponsavel}`,
      data: JSON.stringify(dto),
    });

    return response.data;
  }
  
  async recuperarTermos(filtros) {
    const response = await api({
      method: "GET",
      url: `api/v1/TermoConsentimento?` + filtros,
    });

    return response.data;
  }
}

export default new ServTermoConsentimento();